import { useEffect, useState } from "react";
import useSWR from "swr";
import { Drawer, Loader, Stack, Tabs, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { fetcher } from "../../../../services/fetcher";
import { getTripDetailEndpoint } from "../../utils/tripDrawerConstants";
import TripDrawerHeader from "./TripDrawerHeader";
import TripDrawerOverview from "./TripDrawerOverview";
import TripDrawerTravellers from "./TripDrawerTravellers";
import TripDrawerPaymentActions from "./TripDrawerPaymentActions";
import classes from "./TripPolicyDrawer.module.css";

const TripPolicyDrawer = ({ opened, tripId, onClose, onTravellerClick }) => {
  const isMobile = useMediaQuery("(max-width: 48em)");
  const [tab, setTab] = useState("overview");
  const endpoint = opened && tripId ? getTripDetailEndpoint(tripId) : null;

  const { data, isLoading, error } = useSWR(endpoint, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  useEffect(() => {
    if (opened) setTab("overview");
  }, [opened, tripId]);

  const trip = data?.trip;
  const travellers = data?.travellers || [];
  const count = data?.count ?? travellers.length;

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size={isMobile ? "100%" : "45%"}
      withCloseButton
      classNames={{ body: classes.drawerBody, content: classes.drawerContent }}
      title={
        trip ? (
          <Stack gap={4}>
            <Text size="xs" c="dimmed">POLICY #{trip.id}</Text>
            <Text fw={700} size="lg" lineClamp={2}>{trip.cover_name || "Trip Details"}</Text>
          </Stack>
        ) : (
          "Trip Details"
        )
      }
    >
      {isLoading ? (
        <Stack align="center" py="xl"><Loader size="sm" /></Stack>
      ) : error ? (
        <Text size="sm" c="red">Failed to load trip details.</Text>
      ) : (
        <Stack gap="md">
          <TripDrawerHeader trip={trip} />
          <Tabs value={tab} onChange={setTab}>
            <Tabs.List className={classes.tabList}>
              <Tabs.Tab value="overview">Overview</Tabs.Tab>
              <Tabs.Tab value="travellers">Travellers ({count})</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="overview" pt="md">
              <TripDrawerOverview trip={trip} />
            </Tabs.Panel>
            <Tabs.Panel value="travellers" pt="md">
              <TripDrawerTravellers
                travellers={travellers}
                coverType={trip?.cover_type}
                onTravellerClick={onTravellerClick}
              />
            </Tabs.Panel>
          </Tabs>
          <TripDrawerPaymentActions trip={trip} />
        </Stack>
      )}
    </Drawer>
  );
};

export default TripPolicyDrawer;
